// import modules here
import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {PatientSearchComponent} from './Patient/PatientSearchComponent';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PatientRegisterComponent} from './Patient/PatientRegisterComponent';
import {RouterModule} from '@angular/router';
import {MatSortModule} from '@angular/material/sort';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import { PhoneFormatDirective } from './Directives/phone-format.directive';
import {MatDialogModule} from '@angular/material/dialog';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import {MatChipsModule} from '@angular/material/chips';
import { DatePipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectFilterModule } from 'mat-select-filter';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { MockInterceptor } from './mock.interceptor';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {OverlayModule} from '@angular/cdk/overlay';



// import components here
import {HomeComponent} from './home/homeComponent';
import {PatientDetailComponent} from './Patient/patientDetailComponent';
import {SigninRedirectCallbackComponent} from './auth/signin-redirect-callback.component';
import {SignoutRedirectCallbackComponent} from './auth/signout-redirect-callback.component';
import {AuthInterceptorService} from './auth/AuthInterceptorService';
import {UnauthorizedComponent} from './unauthorized/unauthorized.component';
import {UserComponent} from './user/user.component';
import {AddUserComponent} from './add-user.component';
import {ClientAdminRouteGuard} from './shared/clientadmin-route-guard';
import {AuthGuard} from './auth/Auth-guard';
import {AuthModule} from './auth/auth.module';
import {NavbarComponent} from './components/navbar/navbar.component';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {ReportComponent} from './Menu/report/report.component';
// import {WorkflowComponent} from './Menu/workflow/workflow.component';
import {BulkorderComponent} from './Menu/bulkorder/bulkorder.component';
import {ManualorderComponent} from './Menu/manualorder/manualorder.component';
import {UserworkareaComponent} from './Menu/userworkarea/userworkarea.component';
import {RepositoryComponent} from './Menu/repository/repository.component';
// import {MailComponent} from './Menu/E-Mail/mail/mail.component';
import {InsurancemasterComponent} from './Menu/insurancemaster/insurancemaster.component';
import {UsermanagementComponent} from './Menu/usermanagement/usermanagement.component';
import {SettingsComponent} from './Menu/settings/settings.component';
import {PlantypeComponent} from './Menu/plantype/plantype.component';
import {ClientRegistrationComponent} from './Menu/client-registration/client-registration.component';
import { AddUpdateClientComponent } from './Menu/client-registration/addUpdateClient/add-update-client.component';
import { PatientRegistrationComponent } from './Menu/patient-registration/patient-registration.component';
import {AddUpdatePatientComponent} from './Menu/patient-registration/addUpdatePatient/add-update-patient.component';
import { SsnFormatDirective } from './Directives/ssn-format.directive';
import {FilterPipe} from './Pipes/filterPipe';
import { ZipCodeDirective } from './Directives/zip-code.directive';
import { UserWorkListComponent } from './Menu/user-work-list/user-work-list.component';
import { NoSpaceDirective } from './Directives/no-space.directive';
import { UserCreationComponent } from './Menu/user-creation/user-creation.component';
import { CreateUserComponent } from './Menu/user-creation/create-user/create-user.component';
import {MatRadioModule} from '@angular/material/radio';
import { QuestionnaireComponent } from './Menu/office-registration/questionnaire/questionnaire.component';
import { ProviderRegistrationComponent } from './Menu/provider-registration/provider-registration.component';
import { AddUpdateProviderComponent } from './Menu/provider-registration/add-update-provider/add-update-provider.component';
import { PasswordPatternDirective } from './Directives/password-pattern.directive';
import { RulesRegistrationComponent } from './Menu/rules-registration/rules-registration.component';
import { AddUpdateRulesComponent } from './Menu/rules-registration/add-update-rules/add-update-rules.component';
import { OfficeRegistrationComponent } from './Menu/office-registration/office-registration.component';
import { AddUpdateOfficeComponent } from './Menu/office-registration/add-update-office/add-update-office.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { QuestionsComponent } from './Menu/questions/questions.component';
import { AddquestionComponent } from './Menu/questions/addquestion/addquestion.component';
import { LoaderComponentComponent } from './components/loader-component/loader-component.component';
import { PayerCreationComponent } from './Menu/payer-creation/payer-creation.component';
import { CreatePayerComponent } from './Menu/payer-creation/create-payer/create-payer.component';
import { HmoComponent } from './Menu/Roaster-Upload/hmo.component';
import { AddHeaderComponent } from './Menu/report/add-header/add-header.component';
import { HmonewComponent } from './Menu/hmonew/hmonew.component';
import { ConflictedAccountsComponent } from './Menu/conflicted-accounts/conflicted-accounts.component';
import { ExtractorComponent } from './Menu/extractor/extractor.component';
import { PastingComponent } from './Menu/pasting/pasting.component';
import { EmailAutomationComponent } from './Menu/email-automation/email-automation.component';
import { ProviderListModalComponent } from './Menu/userworkarea/provider-list-modal/provider-list-modal.component';
import { MailConfigComponent } from './Menu/mail-config/mail-config.component';
import { InboxComponent } from './Menu/inbox/inbox.component';
import { ExtractorReportComponent } from './Menu/extractor-report/extractor-report.component';
import { AuditQueueComponent } from './Menu/audit-queue/audit-queue.component';
import { QualityGovernanceComponent } from './Menu/quality-governance/quality-governance.component';
import { AuditReviewComponent } from './Menu/audit-review/audit-review.component';
import { AuditFinalizationComponent } from './Menu/audit-finalization/audit-finalization.component';
import { SeverityConfigurationComponent } from './Menu/severity-configuration/severity-configuration.component';
import { ErrorConfigurationComponent } from './Menu/error-configuration/error-configuration.component';
import { GuidelinesComponent } from './Menu/guidelines/guidelines.component';



@NgModule({
    declarations: [
        AppComponent,
        PatientSearchComponent,
        PatientRegisterComponent,
        PatientDetailComponent,
        HomeComponent,
        UnauthorizedComponent,
        UserComponent,
        AddUserComponent,
        NavbarComponent,
        SidebarComponent,
        ReportComponent,
        // WorkflowComponent,
        BulkorderComponent,
        ManualorderComponent,
        UserworkareaComponent,
        RepositoryComponent,
        // MailComponent,
        InsurancemasterComponent,
        UsermanagementComponent,
        SettingsComponent,
        PlantypeComponent,
        ClientRegistrationComponent,
        PhoneFormatDirective,
        AddUpdateClientComponent,
        FilterPipe,
        PatientRegistrationComponent,
        AddUpdatePatientComponent,
        SsnFormatDirective,
        ZipCodeDirective,
        UserWorkListComponent,
        NoSpaceDirective,
        UserCreationComponent,
        CreateUserComponent,
        QuestionnaireComponent,
        PasswordPatternDirective,
        ProviderRegistrationComponent,
        AddUpdateProviderComponent,
        RulesRegistrationComponent,
        AddUpdateRulesComponent,
        OfficeRegistrationComponent,
        AddUpdateOfficeComponent,
        QuestionsComponent,
        AddquestionComponent,
        LoaderComponentComponent,
        PayerCreationComponent,
        CreatePayerComponent,
        HmoComponent,
        AddHeaderComponent,
        HmonewComponent,
        ConflictedAccountsComponent,
        ExtractorComponent,
        ProviderListModalComponent,
        MailConfigComponent,
        InboxComponent,
        ExtractorReportComponent,
        PastingComponent,
        EmailAutomationComponent,
        AuditQueueComponent,
        QualityGovernanceComponent,
        AuditReviewComponent,
        AuditFinalizationComponent,
        SeverityConfigurationComponent,
        ErrorConfigurationComponent,
        GuidelinesComponent,
    ],
    providers: [
        DatePipe,
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
      { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true }
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        AuthModule,
        RouterModule.forRoot(
            [
                //client
                {path: 'client', component: ClientRegistrationComponent, canActivate:[AuthGuard], data: { roles: ['client-view'] } },
                {path: 'client/register', component: AddUpdateClientComponent, canActivate:[AuthGuard], data: { roles: ['client-edit'] }},
                {path: 'client/details/:id', component: AddUpdateClientComponent,canActivate:[AuthGuard], data: { roles: ['client-edit'] }},

                //patient
                {path: 'patient', component: PatientRegistrationComponent, canActivate:[AuthGuard], data: { roles: ['client-view'] }},
                {path: 'patient/register', component: AddUpdatePatientComponent, canActivate:[AuthGuard], data: { roles: ['client-view', 'client-edit',] }},
                {path: 'patient/details/:id', component: AddUpdatePatientComponent, canActivate:[AuthGuard], data: { roles: ['client-view', 'client-edit'] }},
                //User
                {path: 'user', component: UserCreationComponent, canActivate:[AuthGuard], data: { roles: ['user-view'] }},
                {path: 'user/creation', component: CreateUserComponent, canActivate:[AuthGuard], data: { roles: ['user-view', 'user-edit'] }},
                {path: 'user/details/:id', component: CreateUserComponent, canActivate:[AuthGuard], data: { roles: ['user-view', 'user-edit'] }},
                // Office
                {path: 'office', component: OfficeRegistrationComponent, canActivate:[AuthGuard], data: { roles: ['client-view'] }},
                {path: 'office/register', component: AddUpdateOfficeComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit'] }},
                {path: 'office/details/:id', component: AddUpdateOfficeComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit'] }},
                {path: 'questionnaire', component: QuestionnaireComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit','patient-view'] }},
                {path: 'questionnaire/:id', component: QuestionnaireComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit','patient-view'] }},
                // Staff
                {path: 'provider', component: ProviderRegistrationComponent, canActivate:[AuthGuard], data: { roles: ['client-view','user-view'] }},
                {path: 'provider/register', component: AddUpdateProviderComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit',] }},
                {path: 'provider/details/:id', component: AddUpdateProviderComponent, canActivate:[AuthGuard], data: { roles: ['client-view','client-edit'] }},
                // Rules
                {path: 'rules', component: RulesRegistrationComponent, canActivate:[AuthGuard], data: { roles: ['rule-view',] }},
                {path: 'rules/register', component: AddUpdateRulesComponent, canActivate:[AuthGuard], data: { roles: ['rule-view','rule-edit'] }},
                {path: 'rules/details/:id', component: AddUpdateRulesComponent, canActivate:[AuthGuard], data: { roles: ['rule-view','rule-edit'] }},
                // userworkarea
                {path: 'userworkarea', component:UserWorkListComponent , canActivate:[AuthGuard], data: { roles: ['patient-view','report-view'] }},
                {path: 'userworkarea/details/:id', component: UserworkareaComponent, canActivate:[AuthGuard], data: { roles: ['patient-view', 'patient-edit'], isEditable: true }},
                // report
                {path: 'report', component: ReportComponent, canActivate: [AuthGuard], data: { roles: ['report-view'] }},
                {path: 'header', component: AddHeaderComponent, canActivate: [AuthGuard], data: { roles: ['client-edit'] }},
                //repo
                {path: 'repository', component: RepositoryComponent, canActivate: [AuthGuard] , data: { roles: ['audit-view'] }},
                {path: 'repository/details/:id', component: RepositoryComponent, canActivate:[AuthGuard], data: { roles: ['audit-view'] }},
                // Audit - mock frontend pages until backend APIs are available
                {path: 'audit/quality-governance', component: QualityGovernanceComponent, canActivate:[AuthGuard]},
                {path: 'audit/queue', component: AuditQueueComponent, canActivate:[AuthGuard], data: { roles: ['audit-view', 'audit-edit'] }},
                {path: 'audit/review/:id', component: AuditReviewComponent, canActivate:[AuthGuard], data: { roles: ['audit-view', 'audit-edit'] }},
                {path: 'audit/finalization/:id', component: AuditFinalizationComponent, canActivate:[AuthGuard], data: { roles: ['audit-view', 'audit-edit', 'audit-publish'] }},
                {path: 'audit/severity-configuration', component: SeverityConfigurationComponent, canActivate:[AuthGuard], data: { roles: ['audit-view', 'audit-edit'] }},
                {path: 'audit/error-configuration', component: ErrorConfigurationComponent, canActivate:[AuthGuard], data: { roles: ['audit-view', 'audit-edit'] }},
                //Questions
                {path: 'questions', component: QuestionsComponent},
                {path: 'questions/add', component: AddquestionComponent},
                {path: 'questions/details/:id', component: AddquestionComponent},

                //Payer Creation
                {path: 'payer', component: PayerCreationComponent},
                {path: 'payer/add', component: CreatePayerComponent},
                {path: 'payer/details/:id', component: CreatePayerComponent},

                // HMO
                {path: 'hmoRegistration', component: HmoComponent, canActivate: [AuthGuard]},

                // HMO reborn
                {path: 'hmo', component: HmonewComponent, canActivate: [AuthGuard]},

                // conflicted accounts/duplicate records
                {path: 'conflicted', component: ConflictedAccountsComponent},
                // Extractor
                {path: 'extractor', component: ExtractorComponent},
                {path: 'pasting', component: PastingComponent},
                {path: 'emailAutomation', component: EmailAutomationComponent},
                {path: 'extractorReport', component: ExtractorReportComponent},
                // SOP / Guidelines
                {path: 'guidelines', component: GuidelinesComponent, canActivate: [AuthGuard]},
                //Mail
                // {path: 'smtpConfig', component: SmtpConfigListingComponent}, //SmtpConfigListingComponent
                {path: 'smtpConfig', component: MailConfigComponent},
                // {path: 'smtpConfig/register/:id', component: MailConfigComponent},
                {path: 'inbox', component: InboxComponent},

                {path: 'patientRegister', component: PatientRegisterComponent},
                {path: 'manageUsers', component: UserComponent, canActivate: [ClientAdminRouteGuard]},
                {path: 'addUser', component: AddUserComponent, canActivate: [ClientAdminRouteGuard]},
                {path: 'patientSearch/:searchText', component: PatientSearchComponent, canActivate: [AuthGuard]},
                {path: 'patientDetail/:id', component: PatientDetailComponent},
                {path: 'home', component: HomeComponent, canActivate: [AuthGuard]},

                // {path: 'workflow', component: WorkflowComponent, canActivate: [AuthGuard]},
                {path: 'bulkorder', component: BulkorderComponent, canActivate: [AuthGuard]},

                {path: 'manualorder', component: ManualorderComponent, canActivate: [AuthGuard]},
                // {path: 'mail', component: MailComponent, canActivate: [AuthGuard]},
                {path: 'plantype', component: PlantypeComponent, canActivate: [AuthGuard]},
                {path: 'insurancemaster', component: InsurancemasterComponent, canActivate: [AuthGuard]},
                {path: 'usermanagement', component: UsermanagementComponent, canActivate: [AuthGuard]},
                {path: 'settings', component: SettingsComponent, canActivate: [AuthGuard]},
                {path: 'unauthorized', component: UnauthorizedComponent},
                {path: 'signin-callback', component: SigninRedirectCallbackComponent},
                {path: 'signout-callback', component: SignoutRedirectCallbackComponent},
                {path: '', redirectTo: 'home', pathMatch: 'full', canActivate: [AuthGuard]},
                {path: '**', redirectTo: 'home', pathMatch: 'full'},

            ]
        ),
        BrowserAnimationsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatCardModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatSortModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatDialogModule,
        MatPaginatorModule,
        MatTabsModule,
        MatDatepickerModule,
        MatIconModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatTableModule,
        MatChipsModule,
        MatOptionModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectFilterModule,
        BsDatepickerModule.forRoot(),
        ScrollingModule,
        DragDropModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        OverlayModule

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
